import {CircularProgress} from '@mui/material'
import DataRefetchOnError from '../../common/DataFetchError/DataRefetchOnError'
import MultiSelectDropdownComponent from '../../common/MulitSelectDropdown/MultiSelectDropdownComponent'
import {DropdownLoadingBox} from '../Jurisdiction/JurisdictionStyle'
import {SharedSubTitle} from '../../common/SharedSubTitleStyle'
import loadingTitles from '../../../appConfig/loadingTitles.config.json'
import PropTypes from 'prop-types'
import {StyledSectionTitle} from '../../AdminPanelStyling'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import {useFilterConfig} from '../../../store/hooks/config'

const IndividualHealthFilterComponent = ({
  selectedData,
  setFilterValue,
  handleOptionDeletion,
  enabled,
  isCompleted,
  showCustomLabels,
  setCustomLabelDialogProps,
  hasAnyFilters
}) => {
  const {filterDetailsLoading, filterDetailsError, refetchFilterDetailsList} = useProjectDetails()
  const filterConfig = useFilterConfig()

  function refetchHealthAndConditions(event) {
    event.preventDefault()
    refetchFilterDetailsList()
  }

  const renderDropdown = () => {
    if (filterDetailsLoading) {
      return (
        <DropdownLoadingBox>
          <CircularProgress title={loadingTitles.individualHealthBreadcrumb} />
        </DropdownLoadingBox>
      )
    }

    if (!filterDetailsLoading && filterDetailsError) {
      return <DataRefetchOnError onTryAgain={(event) => refetchHealthAndConditions(event)} />
    }

    // Get Individual Health filters from config
    const individualHealthSection = filterConfig?.data?.find((section) => section.id === '2')
    const individualHealthKeys = individualHealthSection?.filters.map((f) => f.key) || []

    const individualHealthFilters =
      individualHealthSection?.filters.map((filter) => ({
        title: filter.name,
        FILTER_KEY: filter.key,
        FILTER_ID: filter.key,
        IS_ACTIVE: true
      })) || []

    const sortedFilters = individualHealthFilters.sort((a, b) => {
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    })

    // Predicate to check if filter belongs to Individual Health section
    const isIndividualHealthFilter = (filter) => individualHealthKeys.some((key) => filter.FILTER_KEY?.startsWith(key))

    // Filter selectedData to only include Individual Health filters
    const selectedIndividualHealthFilters = selectedData?.filter(isIndividualHealthFilter) || []

    // Wrapper to merge with other filter sections
    const handleIndividualHealthChange = (newFilters) => {
      const otherFilters = selectedData?.filter((filter) => !isIndividualHealthFilter(filter)) || []
      setFilterValue([...otherFilters, ...newFilters])
    }

    return (
      <MultiSelectDropdownComponent
        selectAllTitle='Select All'
        dropDownTitle='Select'
        inputAndPreviewTitle='Individual Health'
        dropDownModifiedTitle='Selected'
        dropDownData={sortedFilters}
        val={selectedIndividualHealthFilters}
        setVal={handleIndividualHealthChange}
        enabled={enabled}
        isCompleted={isCompleted}
        handleOptionDeletion={(type, data, option) => handleOptionDeletion(type, data, option)}
        hasAnyFilters={hasAnyFilters}
        isFilterDropdown={true}
        showCustomLabels={showCustomLabels}
        setCustomLabelDialogProps={setCustomLabelDialogProps}
        section='Individual Health'
      />
    )
  }
  return (
    <>
      <StyledSectionTitle variant='h5'> What Individual Health filters do you want available? </StyledSectionTitle>
      <SharedSubTitle>This is what your client will see when interacting with data on their dashboard</SharedSubTitle>
      {renderDropdown()}
    </>
  )
}

IndividualHealthFilterComponent.propTypes = {
  selectedData: PropTypes.array.isRequired,
  setFilterValue: PropTypes.func.isRequired,
  handleOptionDeletion: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  showCustomLabels: PropTypes.bool,
  setCustomLabelDialogProps: PropTypes.func,
  hasAnyFilters: PropTypes.bool
}

export default IndividualHealthFilterComponent
